{
  "help": "Žinynas",
  "info": "Informacija"
}
